import { useState, useRef, useEffect} from 'react';
import { sandhillsRequest, focusErroredField } from '@Components/Utilities/SandhillsUtility';
import TextField from '@Components/Shared/Controls/TextField';
import TranslationText from '@Components/Utilities/TranslationText';
import ValidationErrors from '@Components/Shared/ValidationErrors';
import translator from '@Components/Utilities/Translator';
import SelectField from '@Components/Shared/Controls/SelectField';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import Modal from '@Components/Shared/Modals/Modal';
import { ValidationRules, ruleRunner, run } from '@Components/Utilities/Validation';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue, useRecoilState } from 'recoil';
import Input from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Calendar from '@Components/MuiWrappers/Calendar';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const RequestAQuoteModal = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const [showModal, setShowModal] = useRecoilState(atoms.showRaq);
    const timeout = useRef(null);
    const inputReferences = useRef({});
    const [success, setSuccess] = useState(false);
    const [hideForm, setHideForm] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const today = new Date();
    const equipmentMessageID = props.Copy ? 0 : props.EquipmentMessageID;
    const [userError, setUserError] = useState(false);
    const [shouldRedirect, setShouldRedirect] = useState(props.TryRedirectSave);
    const [isTestOverride, setIsTestOverride] = useState(props.IsTestOverride);
    const windowSize = useWindowSize();
    const [responseError, setResponseError] = useState(props.ErrorMessage || '');
    const [stateRequired, setStateRequired] = useState(false);

    useEffect(() => {
        if (props.Industry && ((props.Edit && !props.ListingID)|| props.Copy)) {
            getCategoriesForIndustry(props.Industry);
        }
    } , []);

    const inputFontSize = () => {
        if (windowSize.isMobile) {
            return '1rem';
        }
        else {
            return '14px';
        }
    } 

    const sx = {
        '& .MuiOutlinedInput-root.Mui-focused': {
            '& > fieldset': {
                borderColor: 'black'
            }
        },
        backgroundColor: 'white',
        input: {
            fontSize: inputFontSize(),
            color: '#57595b'
        },
        button: {
            marginRight: '10px'
        },
        svg: {
            width: '15px',
            height: '15px'
        },
        width: '100%',
        height: '42px'
    };

    const [formData, setFormData] = useState({
        Industry: props.Industry ? props.Industry : props.Industries ? props.Industries[0].Value : '',
        Industries: props.Industries || [],
        DisableIndustries: (props.ListingID || props.ListingURL?.length > 0) && props.Edit ? true : props.DisableIndustries || false,
        Category: props.Category || '',
        Categories: props.Categories || [],
        DisableCategories: (props.ListingID || props.ListingURL?.length > 0) && props.Edit ? true : props.DisableCategories || false,
        FromDate: new Date(props.FromDate || new Date().toLocaleDateString()),
        ToDate: new Date(props.ToDate || new Date().toLocaleDateString()),
        Quantity: props.Quantity || '',
        City: props.City || '',
        State: props.State || '',
        StateTyped: props.StateTyped || '',
        States: props.States ? props.States : props.GetStateDropDown || [],
        Countries: props.Countries ? props.Countries : props.GetCountryDropDown || [],
        Country: props.Country || '',
        PostalCode: props.PostalCode || '',
        Manufacturer: props.Manufacturer || '',
        DisableManufacturer: props.DisableManufacturer || false,
        Model: props.Model || '',
        DisableModel: props.DisableModel || false,
        Comments: props.Comments || ''
    });
    useEffect(() => {
        if (shouldRedirect) {
            onSubmit();
            setShouldRedirect(false);
        }
        if(formData.States.length > 0) {
            setStateRequired(true);
        }
    });

    const onBeginDateChange = (date) => {
        setFormData(previousState => {
            return { ...previousState, FromDate: date };
        });
    };
    const onEndDateChange = (date) => {
        setFormData(previousState => {
            return { ...previousState, ToDate: date };
        });
    };

    const submitForm = (e) => {
        e.preventDefault();
        let errors = run(formData, [
            ruleRunner('Industry', translator.translate('sandhills.industry'), ValidationRules.required),
            ruleRunner('Category', translator.translate('sandhills.category'), ValidationRules.required),
            ruleRunner('FromDate', translator.translate('sandhills.datefrom'), ValidationRules.required),
            ruleRunner('ToDate', translator.translate('sandhills.dateto'), ValidationRules.required),
            ruleRunner('Quantity', translator.translate('sandhills.quantity'), ValidationRules.required, ValidationRules.isWholeNumber, ValidationRules.mustBeGreaterThanEqualToValue(1, false)),
            ruleRunner('Manufacturer', translator.translate('sandhills.manufacturer')),
            ruleRunner('Model', translator.translate('sandhills.model')),
            ruleRunner('Country', translator.translate('sandhills.country'), ValidationRules.required),
            ruleRunner('State', translator.translate('sandhills.stateprovince')),
            ruleRunner('StateTyped', translator.translate('sandhills.stateprovince')),
            ruleRunner('City', translator.translate('sandhills.city'), ValidationRules.required),
            ruleRunner('PostalCode', translator.translate('sandhills.postalcode')),
            ruleRunner('Comments', translator.translate('sandhills.comments'))
        ]);

        setValidationErrors(errors);
        focusErroredField(errors, inputReferences);
        if (Object.keys(errors).length <= 0) {
            setSuccess(false);
            setDisableSubmit(true);
            if (!currentUser.IsAuthenticated) {
                var qsStart = window.location.href.includes('?') ? '&' : '?';
                window.location.href = routes.SSO + '?to=' + encodeURIComponent(window.location.href + qsStart + 'FromDate=' + formData.FromDate.toISOString() + '&ToDate=' + formData.ToDate.toISOString() + '&City=' + formData.City + '&State=' + formData.State + '&StateTyped=' + formData.StateTyped + '&Country=' + formData.Country + '&PostalCode=' + formData.PostalCode + '&Comments=' + formData.Comments + '&Quantity=' + formData.Quantity + '&raq=1');
            }
            else {
                onSubmit();
            }           
        }
    };

    const onSubmit = (token) => {
        sandhillsRequest({
            url: routes.QuoteRequestSave,
            method: 'post',
            data: {
                EquipmentMessageID: equipmentMessageID,
                ListingID: props.ListingID,
                EquipmentMessageStatus: props.Copy ? 2 : props.EquipmentMessageStatus,
                AcceptedBidCRMID: props.Copy ? 0 : props.AcceptedBidCRMID,
                EquipmentMessagePriceQuoteID: props.Copy ? 0 : props.EquipmentMessagePriceQuoteID,
                Industry: formData.Industry,
                Category: formData.Category,
                FromDate: formData.FromDate,
                ToDate: formData.ToDate,
                Quantity: formData.Quantity,
                City: formData.City,
                State: formData.State,
                StateTyped: formData.StateTyped,
                Country: formData.Country,
                PostalCode: formData.PostalCode,
                Manufacturer: formData.Manufacturer,
                Model: formData.Model,
                Comments: formData.Comments,
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setSuccess(data.Success);
            setDisableSubmit(false);
            setValidationErrors(data.ValidationErrors || {});
            focusErroredField(data.ValidationErrors, inputReferences);
            if (data.Success) {
                setFormData(previousState => {
                    return {
                        ...previousState,
                        Industry: data.Industry ? data.Industry : data.Industries ? data.Industries[0].Value : '',
                        Industries: data.Industries || [],
                        Category: data.Category ? data.Category : data.Categories ? data.Categories[0].Value : '',
                        Categories: data.Categories || [],
                        FromDate: new Date(data.FromDate || new Date().toLocaleDateString()),
                        ToDate: new Date(data.ToDate || new Date().toLocaleDateString()),
                        Quantity: data.Quantity || '',
                        City: data.City || '',
                        State: data.State || '',
                        StateTyped: data.StateTyped || '',
                        States: data.States ? data.States : data.GetStateDropDown || [],
                        Country: data.Country || '',
                        Countries: data.Countries ? data.Countries : data.GetCountryDropDown || [],
                        PostalCode: data.PostalCode || '',
                        Manufacturer: data.Manufacturer || '',
                        Model: data.Model || '',
                        Comments: data.Comments || ''
                    };
                });
                setIsTestOverride(data?.IsTestOverride); 
                setHideForm(true);
                timeout.current = closeModalTimer();
                if (props.setQuoteRequest) {
                    props.setQuoteRequest(previousState => {
                        return {
                            ...previousState,
                            RentalDates: new Date(data.FromDate || new Date()).toLocaleDateString() + " - " + new Date(data.ToDate || new Date()).toLocaleDateString(),
                            Quantity: data.Quantity || '',
                            Location: (data.City || '') + ' ' + (data.State || '') + ', ' + (data.Country || ''),
                            Manufacturer: data.Manufacturer || '',
                            Model: data.Model || '',
                            Comment: data.Comments || '',
                            RequestAQuoteModel: {
                                ...previousState,
                                Industry: data.Industry ? data.Industry : data.Industries ? data.Industries[0].Value : '',
                                Industries: data.Industries || [],
                                Category: data.Category ? data.Category : data.Categories ? data.Categories[0].Value : '',
                                Categories: data.Categories || [],
                                FromDate: new Date(data.FromDate || new Date().toLocaleDateString()),
                                ToDate: new Date(data.ToDate || new Date().toLocaleDateString()),
                                Quantity: data.Quantity || '',
                                City: data.City || '',
                                State: data.State || '',
                                StateTyped: data.StateTyped || '',
                                States: data.States? data.States : data.GetStateDropDown || [],
                                Country: data.Country || '',
                                Countries: data.Countries? data.Countries : data.GetCountryDropDown || [],
                                PostalCode: data.PostalCode || '',
                                Manufacturer: data.Manufacturer || '',
                                Model: data.Model || '',
                                Comments: data.Comments || '',
                            }
                        };
                    });
                }
            } else {
                setResponseError(data.ErrorMessage || '');
                if (!currentUser.IsAuthenticated || (props.IsEmployee && !data?.IsTestOverride)) {
                    setUserError(true);
                    setHideForm(true);
                }
                setValidationErrors(data.ValidationErrors || {});
            }
        });
    };

    const getCategoriesForIndustry = (baseCategory) => {
        if (baseCategory) {
            sandhillsRequest({
                url: routes.GetCategoriesByIndustry,
                data: {
                    baseCatID: baseCategory,
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((response) => {
                let data = response || [];
                setFormData(previousState => {
                    return { ...previousState, Industry: baseCategory, Category: props.Category || formData.Category, Categories: data };
                });
            });
        } else {
            setFormData(previousState => {
                return { ...previousState, Industry: formData.Industries, Category: formData.Category, Categories: formData.Categories };
            });
        }
    };

    const getAutoCompleteUrl = (e, url) => {
        return url;
    };

    const getAutoCompleteData = (e) => {
        return {
            text: e.target.value,
            categoryIDs: formData.Category,
            manufacturer: formData.Manufacturer
        };
    };

    const resetModal = () => {
        setFormData({
            Industry: props.Industry ? props.Industry : props.Industries ? props.Industries[0].Value : '',
            Industries: props.Industries || [],
            DisableIndustries: (props.ListingID || props.ListingURL?.length > 0) && props.Edit ? true : props.DisableIndustries || false,
            Category: props.Category || '',
            Categories: props.Categories || [],
            DisableCategories: (props.ListingID || props.ListingURL?.length > 0) && props.Edit ? true : props.DisableCategories || false,
            FromDate: new Date(props.FromDate || new Date().toLocaleDateString()),
            ToDate: new Date(props.ToDate || new Date().toLocaleDateString()),
            Quantity: props.Quantity || '',
            City: props.City || '',
            State: props.State || '',
            StateTyped: props.StateTyped || '',
            States: props.States ? props.States : props.GetStateDropDown || [],
            Countries: props.Countries ? props.Countries : props.GetCountryDropDown || [],
            Country: props.Country || '',
            PostalCode: props.PostalCode || '',
            Manufacturer: props.Manufacturer || '',
            DisableManufacturer: props.DisableManufacturer || false,
            Model: props.Model || '',
            DisableModel: props.DisableModel || false,
            Comments: props.Comments || ''
        });
        setHideForm(false);
        setSuccess(false);
    };

    const closeModalTimer = () => setTimeout(() => {
        props.toggleModal ? props.toggleModal() : setShowModal(false);
        resetModal();
    }, 3000);

    const countryChange = (e) => {
        let country = e.target.value;
        setFormData(previousState => {
            return {
                ...previousState,
                Country: country,
                DisableState: false,
                City: '',
                PostalCode: '',
                State: '',
                StateTyped: ''
            };
        });
        sandhillsRequest({
            url: routes.GetStatesByCountry,
            data: {
                'CountryName': country,
                'DefaultText': translator.translate('sandhills.registration.selectastateprovince')
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setFormData(previousState => {
                return {
                    ...previousState,
                    States: data,
                    StateTyped: ''
                };
            });
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, [name]: value };
        });
    };
    const onStateChange = (e) => {
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, State: value, StateTyped: '' };
        });
    };
    const onStateTypedChange = (e) => {
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, StateTyped: value, State: '' };
        });
    };

    const onIndustryChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(previousState => {
            return {
                ...previousState, [name]: value,
                DisableCategories: false,
            };
        });
        getCategoriesForIndustry(e.target.value)
    }
    const onCategoryChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, [name]: value, DisableManufacturer: false };
        });
    }
    const onManufacturerChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, [name]: value, DisableModel: false };
        });
    }

    const closeModal = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        props.toggleModal ? props.toggleModal() : setShowModal(false);
        resetModal();
    };

    const resetSubmit = () => {
        setDisableSubmit(false);
    };

    return (
        <>
            {(showModal || props.showRequestAQuoteModal) &&
            <Modal containerClassName='feedback-modal' onEscapeKeyClose={closeModal}>
                <Modal.Header onClose={closeModal}>
                    <Modal.Title>
                        {props.Edit ? <span>{translator.translate('sandhills.edit')} {translator.translate('sandhills.requestaquote')}</span> : props.Copy ? <span>{translator.translate('sandhills.tradepubwebsite.mvc.copy')} {translator.translate('sandhills.requestaquote')}</span> : "" }
                        {!props.Edit && !props.Copy && (props.ListingTitle ? <span>{translator.translate('sandhills.requestaquote')} for {props.ListingTitle}</span> : <span>{translator.translate('sandhills.requestaquote')}</span>)}
                        {isTestOverride && <span> - Employee Test</span>}
                    </Modal.Title>
                    {userError &&
                        <>
                            {props.IsEmployee && !isTestOverride && <p className='error'>{translator.translate('sandhills.quoterequestemployee')}</p>}
                            {!currentUser.IsAuthenticated && !isTestOverride && <p className='error'>{translator.translate('sandhills.quoterequestlogin')}</p>}
                        </>}
                    {success &&
                        <>
                            {isTestOverride && <p className='success'>Your Test Rental Quote Email Lead Was Successfully Sent</p> }
                            {props.Edit && !isTestOverride && <p className='success'>{translator.translate('sandhills.quoterequestupdated')}!</p>}
                            {!isTestOverride && !props.Edit && <p className='success'>{translator.translate('sandhills.quoterequestsent')}!</p>}
                        </>}
                </Modal.Header>
                <Modal.Body>
                    <p id='description-label' className='hidden'>Request A Quote</p>
                    <form className={'contact-form-modal' + (hideForm ? ' hide' : '')} name='feedbackForm' onSubmit={submitForm}>
                        <ValidationErrors errors={validationErrors} />
                        {responseError && <p className='error'>{responseError}</p>}
                        <div className='form-main-content'>
                            <div className='left-col'>
                                {formData.Industries && formData.Industries.length > 0 &&
                                    <SelectField
                                        id='Industry'
                                        name='Industry'
                                        id='Industry'
                                        disabled={formData.DisableIndustries}
                                        value={formData.Industry}
                                        options={formData.Industries}
                                        label={<TranslationText tKey='sandhills.industry' />}
                                        class='form-el'
                                        selectClass='select-dropdown'
                                        required={true}
                                        validationErrors={validationErrors.Industry}
                                        ref={(element) => inputReferences.current[`Industry`] = element}
                                        onFieldChanged={onIndustryChange}
                                    />}
                                {formData.Categories && formData.Categories.length > 0 &&
                                    <SelectField
                                        id='Category'
                                        name='Category'
                                        id='Category'
                                        value={formData.Category}
                                        disabled={formData.DisableCategories}
                                        options={formData.Categories}
                                        label={<TranslationText tKey='sandhills.category' />}
                                        class='form-el'
                                        selectClass='select-dropdown'
                                        required={true}
                                        validationErrors={validationErrors.Category}
                                        ref={(element) => inputReferences.current[`Category`] = element}
                                        onFieldChanged={onCategoryChange}
                                    />}
                                <div className='form-el'>
                                    <label htmlFor='FromDate' className='bold'><TranslationText tKey='Sandhills.DateFrom' /> <span className='required red' /></label>
                                    <Box sx={{ width: '100%' }}>
                                        <Calendar
                                            id='FromDate'
                                            value={formData.FromDate}
                                            onChange={onBeginDateChange}
                                            inputFormat='MM/dd/yyyy'
                                            PopperProps={{ disablePortal: true }}
                                            minDate={today}
                                            validationErrors={validationErrors.FromDate}
                                            DialogProps={{
                                                sx: {
                                                    zIndex: 1600
                                                }
                                            }}
                                            InputAdornmentProps={{
                                                sx: {
                                                    margin: '0px'
                                                }
                                            }}
                                            sx={sx}
                                        />
                                    </Box>

                                </div>
                                <div className='form-el'>
                                    <label htmlFor='ToDate' className='bold'><TranslationText tKey='Sandhills.DateTo' /> <span className='required red' /></label>
                                    <Box sx={{ width: '100%' }}>
                                        <Calendar
                                            id='ToDate'
                                            value={formData.ToDate}
                                            onChange={onEndDateChange}
                                            minDate={formData.FromDate}
                                            inputFormat='MM/dd/yyyy'
                                            PopperProps={{ disablePortal: true }}
                                            validationErrors={validationErrors.ToDate}
                                            DialogProps={{
                                                sx: {
                                                    zIndex: 1600
                                                }
                                            }}
                                            InputAdornmentProps={{
                                                sx: {
                                                    margin: '0px'
                                                }
                                            }}
                                            sx={sx}
                                        />
                                    </Box>

                                </div>
                                <TextField
                                    id='Quantity'
                                    name='Quantity'
                                    value={formData.Quantity}
                                    placeholder={translator.translate('sandhills.quantity')}
                                    type='text'
                                    label={<TranslationText tKey='sandhills.quantity' />}
                                    class='form-el'
                                    required={true}
                                    validationErrors={validationErrors.Quantity}
                                    ref={(element) => inputReferences.current[`Quantity`] = element}
                                    onFieldChanged={onChange}
                                />
                                <TextField
                                    id='ManufacturerModal'
                                    name='Manufacturer'
                                    value={formData.Manufacturer}
                                    type='text'
                                    disabled={formData.DisableManufacturer}
                                    label={<TranslationText tKey='sandhills.manufacturer' />}
                                    class='form-el'
                                    required={false}
                                    updateField={(value) => setFormData(previousState => {
                                        return { ...previousState, Manufacturer: value };
                                    })}
                                    placeholder={translator.translate('sandhills.tradepubwebsite.mvc.starttypingtoselectamanufacturer')}
                                    validationErrors={validationErrors.Manufacturer}
                                    ref={(element) => inputReferences.current[`Manufacturer`] = element}
                                    onFieldChanged={onManufacturerChange}
                                    autoComplete={{
                                        ajaxUrl: (e) => getAutoCompleteUrl(e, routes.GetManuAutoComplete),
                                        postData: (e) => getAutoCompleteData(e)
                                    }}
                                />
                                <TextField
                                    id='ModelModal'
                                    name='Model'
                                    value={formData.Model}
                                    type='text'
                                    label={<TranslationText tKey='sandhills.model' />}
                                    class='form-el'
                                    required={false}
                                    placeholder={translator.translate('sandhills.tradepubwebsite.mvc.starttypingtoselectamodel')}
                                    validationErrors={validationErrors.Model}
                                    ref={(element) => inputReferences.current[`Model`] = element}
                                    disabled={formData.DisableModel}
                                    onFieldChanged={onChange}
                                    autoComplete={{
                                        ajaxUrl: (e) => getAutoCompleteUrl(e, routes.GetModelAutoComplete),
                                        postData: (e) => getAutoCompleteData(e)
                                    }}
                                    updateField={(value) => setFormData(previousState => {
                                        return { ...previousState, Model: value };
                                    })}
                                />
                            </div>
                            <div className='right-col'>
                                <SelectField
                                    id='Country'
                                    name='Country'
                                    id ='Country'
                                    value={formData.Country}
                                    options={formData.Countries}
                                    label={<TranslationText tKey='sandhills.country' />}
                                    class='form-el'
                                    selectClass='select-dropdown'
                                    required={true}
                                    validationErrors={validationErrors.Country}
                                    ref={(element) => inputReferences.current[`Country`] = element}
                                    onFieldChanged={countryChange}
                                />
                                <TextField
                                    id='City'
                                    name='City'
                                    value={formData.City}
                                    placeholder={translator.translate('sandhills.city')}
                                    type='text'
                                    label={<TranslationText tKey='sandhills.city' />}
                                    class='form-el'
                                    required={true}
                                    validationErrors={validationErrors.City}
                                    ref={(element) => inputReferences.current[`City`] = element}
                                    onFieldChanged={onChange}
                                    htmlAutoComplete='chrome-off'
                                />
                                {formData.States.length > 1 ?
                                    <SelectField
                                        id='State'
                                        name='State'
                                        id='State'
                                        value={formData.State}
                                        options={formData.States}
                                        label={<TranslationText tKey='sandhills.stateprovince' />}
                                        class='form-el'
                                        selectClass='select-dropdown'
                                        required={stateRequired}
                                        validationErrors={validationErrors.State}
                                        ref={(element) => inputReferences.current[`State`] = element}
                                        onFieldChanged={onStateChange}
                                    />
                                    :
                                    <TextField
                                        id='StateTyped'
                                        name='StateTyped'
                                        value={formData.StateTyped}
                                        type='text'
                                        label={<TranslationText tKey='sandhills.stateprovince' />}
                                        class='form-el'
                                        required={false}
                                        validationErrors={validationErrors.StateTyped}
                                        ref={(element) => inputReferences.current[`StateTyped`] = element}
                                        onFieldChanged={onStateTypedChange}
                                    />}
                                <TextField
                                    id='PostalCode'
                                    name='PostalCode'
                                    value={formData.PostalCode}
                                    placeholder={translator.translate('sandhills.enteryourpostalcode')}
                                    type='text'
                                    label={<TranslationText tKey='sandhills.postalcode' />}
                                    class='form-el'
                                    required={false}
                                    validationErrors={validationErrors.PostalCode}
                                    ref={(element) => inputReferences.current[`PostalCode`] = element}
                                    onFieldChanged={onChange}
                                />
                                <TextField
                                    id='Comments'
                                    name='Comments'
                                    value={formData.Comments}
                                    placeholder={translator.translate('sandhills.tradepubwebSite.mvc.comments')}
                                    type='textarea'
                                    label={<TranslationText tKey='sandhills.tradepubwebSite.mvc.comments' />}
                                    class='form-el text-area-container'
                                    inputClass='text-area'
                                    validationErrors={validationErrors.Comments}
                                    ref={(element) => inputReferences.current[`Comments`] = element}
                                    onFieldChanged={onChange}
                                />
                            </div>
                        </div>
                        <div className='form-bottom'>
                            <input className='ts-button recaptcha-submit-button button' type='submit' id='request-a-quote-submit-button' name='request-a-quote-submit-button' value={translator.translate('sandhills.tradepubwebsite.mvc.submit')} disabled={disableSubmit} />
                        </div>
                        {disableSubmit && <LoadingRing backdrop />}
                    </form>
                </Modal.Body>
            </Modal>
            }
        </>
    );
};

export default RequestAQuoteModal;